import React from 'react';
import classNames from 'classnames';

import { Nullable } from 'src/types/nullable.type';

interface Props {
  logoUrl: Nullable<string>;
  containerClasses?: string;
}

const PersonalizatonLogo = ({ logoUrl, containerClasses }: Props) => {
  return (
    <div className={classNames('flex items-center justify-center', containerClasses)}>
      <div className='w-full h-full left-0 top-0 flex items-center justify-center rounded-lg'>
        {logoUrl && <img src={logoUrl} alt='' className='block w-auto h-auto max-h-[20px] max-w-[20px] rounded-sm' />}
      </div>
    </div>
  );
};

export default PersonalizatonLogo;
